module.exports = __webpack_public_path__ + "static/media/qrwall.f18eaaed.png";